import { baseUrl } from '@/api/types';

export function onboardingPersonalizationIndexUrl() {
  return `${baseUrl}/onboarding-personalization`;
}

export function onboardingPersonalizationUpdateUrl() {
  return `${baseUrl}/onboarding-personalization`;
}

export function onboardingPersonalizationSkipUrl() {
  return `${baseUrl}/onboarding-personalization/skip`;
}

export function onboardingGuideEditUrl() {
  return `${baseUrl}/onboarding-guide`;
}
